module.exports = __webpack_public_path__ + "1f52078081f2cf4d48b53f238892f409.svg";